import { render, staticRenderFns } from "./lancarRelatorioDescritivoPage.vue?vue&type=template&id=25ae6dfe"
import script from "./lancarRelatorioDescritivoPage.vue?vue&type=script&lang=js"
export * from "./lancarRelatorioDescritivoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports